export default __webpack_public_path__ + "static/media/2324 cutlery side.2d25f0d2.png";